<footer data-aos="fade-down" data-aos-duration="600" data-aos-easing="ease-in-sine">
  <div class="row primary" data-aos="fade-down" data-aos-duration="1000" data-aos-easing="ease-in-sine">

    <div class="column-logo" style="align-items: center;">
      <div class="logo">
        <img src="../../../assets/images/studenty.png" alt="">
        <h1>STUDENTY</h1>
       <a href="https://www.facebook.com/profile.php?id=100090740510561" target="_blank"> <i class="fa-brands fa-facebook-f" style="border: 2px solid;margin-right:20px; width:2em; height:2em; color:white"></i></a>
        <a href="https://www.facebook.com/profile.php?id=100090740510561" target="_blank"><fa-icon [icon]="faYoutube" style="color:white;font-size: 2em;margin-right:20px;"></fa-icon></a>
        <a href="https://www.instagram.com/studenty.23/" target="_blank"><fa-icon [icon]="faInstagram" style="color:white;margin-right:20px; font-size: 2em;"></fa-icon></a>
        <a href="https://www.linkedin.com/company/studenty-tunisie/" target="_blank"> <fa-icon [icon]="faLinkedIn" style="color: white;margin-right:20px;font-size: 2em;"></fa-icon></a>
      </div>
    </div>

    <div class="column about" style="text-align: center;" >
      <h4 >Menu</h4>
      <a href="#">Home</a>
      <a href="#">How it works?</a>
      <a href="#">Events</a>
      <a href="#">Blog</a>
      <a href="#">Partnership</a>
    </div>

    <div class="column about" style="text-align: center;">
      <h4>A Propos de nous</h4>
      <a href="#">Notre Entreprise</a>
      <a href="#">Nous Objectives</a>
      <a href="#">Responsabilité Sociale</a>
      <a href="#">Nos Bureau</a>
      <a href="#">Plus D'informations</a>
    </div>

    <div class="column subscribe">
      <div class="section-heading">
        <h4 style="text-align: center;">Get in touch</h4>
      </div>
      <div class="col-sm-6">
        <form action="#">
          <div class="form-row">
            <div class="col dk-footer-form">
              <input class="form-control" type="text" placeholder="Email" aria-label="Email" aria-describedby="button-addon2" style="margin-bottom: 20px;">
              <button class="btn btn-primary" id="button-addon2" type="submit" style="margin-bottom: 20px;">
                <fa-icon [icon]="faSend"style="color:white ; font-size: 2em; margin-bottom:30px;"></fa-icon>
              </button>
              <div class="icons" style="flex-direction:row;width: 150% ;">
                <fa-icon [icon]="faPhone" style="color:white;font-size: large;"></fa-icon>
                <a href="#" style="display: inline;margin-left: 25px; margin-top: 20px;">+216 123 123 123</a>
                <br />
                <fa-icon [icon]="faEmail" style="color:white; font-size: large; "></fa-icon>
                <a href="#" style="display: inline;margin-left: 25px; ">contact.pikoro@gmail.com</a>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</footer>

<div class="copyright-text" >
  <p> Powred by  PIKORO 2023 © | All Rights Reserved</p>
</div>
